import React, {useEffect, useState} from "react";

import {Col, Form, InputGroup, Row} from "react-bootstrap";
import {simpleFilterParam} from "../../../dtos/PatientSearchDTO";
import {paramValue} from "../../dropDownLists/sharedDDL";
import {Filter} from "./components";

const componentName = "FreeText";
const Free_Text_TYPE = "FreeText";

const FreeText = ({
  header,
  handleChange,
  selected,
  highlightWhenHasValue = true,
  comparisonValue = "eq",
  externalDataMap,
  onLoad,
  showRequired,
  onlyNumbers,
  showSearch = true,
  showSearchIcon = true
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [text, setText] = useState(paramValue(selected)[0])
  const idFragment = header.replaceAll(" ", "_").toUpperCase();

  useEffect(() => {
    setText(paramValue(selected)[0] ?? "");
  }, [selected]);

  const onChange = (value) => {
    handleChange(simpleFilterParam(header, comparisonValue, value));
    setText(value)
  };

  const onTextChange = (e) => {
    const value = e.target.value ? e.target.value : "";

    if(onlyNumbers){
      const re = /^\d*(\.\d+)?$/;
      if(re.test(value)){
        onChange(value);
      }
    }else{
      onChange(value);
    }
  };

  if (onLoad) {
    onLoad(
      externalDataMap,
      simpleFilterParam(header, comparisonValue, text),
      onChange
    );
  }

  const onFocus = () => {
    setIsFocused(true);
  };

  const onBlur = () => {
    setIsFocused(false);
  };

  const notFocusedAndHashData = () => {
    return !isFocused && text;
  };

  const HeaderComponent = () => {
    return (
      <label id={`${componentName}-${idFragment}-filterTitle`} className="d-block">
        <span id={`${componentName}-${idFragment}-filterTitleText`}>{header}</span>
        {showRequired && <span className="text-danger">*</span>}
        {notFocusedAndHashData() ? (
          <>
            <i id={`${componentName}-${idFragment}-filterReset`} className="fas fa-circle fa-2xs cursor-p d-inline-block ms-2 me-0 text-primary"></i>
          </>
        ) : (
          ""
        )}
      </label>
    )
  }
  return (
    <Row lg={1}>
      <Col>
        <Filter index={`${componentName}-${idFragment}-filter`} header={<HeaderComponent />}>
          <InputGroup>
            {
              (showSearch && showSearchIcon) && ((!text || text?.length <= 0) && !onlyNumbers) &&
                <div className="search-icon" style={{ padding: "5px" }}>
                  <i className="fas fa-search" style={{ color: "#6c757d" }}/>
                </div>
            }
            <Form.Control
              id={`${componentName}-${idFragment}-filterValue`}
              type="text"
              value={text ? text : ""}
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={onTextChange}
              data-active-closed-filter={highlightWhenHasValue && notFocusedAndHashData()}
              placeholder={onlyNumbers ? "" : showSearch ? "Search" : ""}
            />
          </InputGroup>
        </Filter>
      </Col>
    </Row>
  );
};

export { FreeText, Free_Text_TYPE };
